import React from 'react';
import {
	Box,
	HStack,
	Popover,
	PopoverTrigger,
	Portal,
	PopoverContent,
	PopoverBody,
	Text,
	VStack,
	useColorMode,
} from '@chakra-ui/react';
import { MenuBars, CalendarMonth, CalendarWeek, CalendarDay, CalendarAgenda } from '../../icons';
import { RADIUS, useCalendarSettings, useIconColor } from '../../../lib';

interface IViewMenuProps {
	views: string[];
	createViewChangeHandler: (viewType: string) => () => void;
	viewLabels: { [key: string]: string };
	isDesktop?: boolean;
}

const viewIcons = {
	month: CalendarMonth,
	week: CalendarWeek,
	day: CalendarDay,
	agenda: CalendarAgenda,
};

export const ViewMenu = ({ isDesktop, views, createViewChangeHandler, viewLabels }: IViewMenuProps) => {
	const { settings } = useCalendarSettings();
	const { colorMode } = useColorMode();
	const iconColor = useIconColor();

	const { calendarBordersColor } = settings.styles[colorMode];
	return (
		<>
			<Popover>
				<PopoverTrigger>
					<Box
						paddingTop='10px'
						paddingBottom='10px'
						paddingInline='7px'
						margin='0px !important'
						border={isDesktop ? '' : `1px solid ${calendarBordersColor}`}
						borderLeft='none'
						borderBottomRightRadius={!isDesktop ? RADIUS[settings.radius.toolbar] : 0}
					>
						<MenuBars size={20} fill={iconColor} />
					</Box>
				</PopoverTrigger>
				<Portal>
					<PopoverContent width='fit-content' boxShadow='md'>
						<PopoverBody boxShadow='md'>
							<VStack alignItems='flex-start'>
								{views.map((viewType) => {
									//factory function to get the handler
									const handleViewChange = createViewChangeHandler(viewType);
									const Icon = viewIcons[viewType];
									return (
										<HStack key={viewType} p={4} onClick={handleViewChange} cursor='pointer'>
											<Icon size={20} fill={iconColor} />
											<Text>{viewLabels[viewType]}</Text>
										</HStack>
									);
								})}
							</VStack>
						</PopoverBody>
					</PopoverContent>
				</Portal>
			</Popover>
		</>
	);
};
